import React from "react"
import { legalNotice } from "./affiliateMarketing.module.css"

const LegalNotice = disclosure => {
  return <p className={legalNotice}>{disclosure.legal}</p>
}

export default LegalNotice
